import { apiFetch } from '@/api'
import { Observation } from '@/interfaces'

export const fetchAllObservations = async (): Promise<Observation> =>
  (await apiFetch('/observations', { method: 'GET' })).data
